import * as React from 'react';
import { useDataLoader } from 'react-remote-data-hooks';
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { toastr } from 'react-redux-toastr';
import { RequirementRejectReason } from "../../../../core/api/models";
import api from '../../../../api';
import CreateForm from './CreateForm';
import { useHasPermission } from '../../../../core/hooks';
import { StatusCodes } from 'http-status-codes';
import { AppPermissions } from '../../../../core';
import { useMasterData } from '../../../../core/hooks/useMasterData';

const InvoiceTransactionIntent: React.FunctionComponent = () => {
  const canCreateRequirementReason = useHasPermission(
    AppPermissions.CreateInvoiceReason
  );
  const [editModal, setEditModal] = useStateWithCallbackLazy<{
    data?: RequirementRejectReason;
    isOpen?: boolean;
  }>({});
  const masterData = useMasterData(api.settings);
  const [updateError, setUpdateError] = React.useState('');
  const [updating, setUpdating] = React.useState(Boolean);
  const [isDeleteModalOpen, setDeleteModalOpen] = React.useState<boolean>(
    false
  );

  const { data, reload } = useDataLoader<RequirementRejectReason[]>(() =>
    api.AddNewRequirement.loadAllRequirementRejectReason({ entityType: 'InvoiceTransactionRevert' })
  );

  const reasonUpdate = async (updateData: RequirementRejectReason) => {
    try {
      const id = editModal?.data?._id;
      setUpdating(true);
      const response = id
        ? await api.AddNewRequirement.updateRequirementRejectReason(
          { ...updateData, entityType: 'InvoiceTransactionRevert' },
          editModal?.data?._id
        )
        : await api.AddNewRequirement.createRequirementRejectReason(
          { ...updateData, entityType: 'InvoiceTransactionRevert' },
          editModal?.data?._id
        );
      if (response.status === StatusCodes.OK) {
        setEditModal({}, () => {
          reload();
          masterData.loadMasterData();
        });
      } else {
        setUpdateError('Unable to update details');
      }
      setUpdating(false);
    } catch (error) {
      setUpdateError('Unable to update details');
      setUpdating(false);
    }
  };

  const showCreateModal = () => {
    setEditModal({}, () => {
      setEditModal({ isOpen: true }, () => {
        // console.log("model closed")
      });
    });
  };

  const onDelete = async (id?: string) => {
    try {
      await api.AddNewRequirement.deleteRequirementRejectReason(id);
      toastr.success('Success', 'Reason deleted successfully');
      setDeleteModalOpen(false)
      reload();
      closeModal()
    } catch (error) {
      toastr.error('Error', 'Failed to delete');
    }
  };

  const closeModal = () => {
    setEditModal({}, () => {
      // console.log("model closed")
    });
  };

  const showEditModal = (modeData: RequirementRejectReason) => {
    setEditModal({}, () => {
      setEditModal({ data: modeData, isOpen: true }, () => {
        // console.log("model closed")
      });
    });
  };

  return (
    <>
      <div className="col-lg-5 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col">
            <h4 className="mb-0 font-weight-semibold">Invoice Transaction Rejected Reason</h4>
          </div>
          {canCreateRequirementReason && (
            <div className="col-auto text-right">
              <button
                className="btn btn-link font-normal font-weight-semibold px-2 py-2 d-inline-flex align-items-center"
                onClick={() => showCreateModal()}
              >
                <i className="icon-plus mr-1 font-xs"></i> Add
              </button>
            </div>
          )}
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                {/* <th>
                  <span className="d-inline-flex align-items-center">Code</span>
                </th> */}
                <th>
                  <span className="d-inline-flex align-items-center">Name</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item) => {
                return (
                  <tr
                    onClick={() => showEditModal(item)}
                    className="cursor-pointer"
                  >
                    {/* <td>{item.code}</td> */}
                    <td>{item.reason}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
        {editModal.isOpen && (
          <>
            <div className="text-right d-md-none">
              <i className="icon-close"></i>
            </div>
            <CreateForm
              onSubmit={(formData) => reasonUpdate(formData)}
              isSubmitting={updating}
              error={updateError}
              data={editModal.data}
              onCancel={() => closeModal()}
              onDelete={(id?: string) => onDelete(id)}
              isDeleteModalOpen={isDeleteModalOpen}
              setDeleteModalStatus={(status: boolean) => setDeleteModalOpen(status)}
            ></CreateForm>
          </>
        )}
      </div>
    </>
  );
};

export default InvoiceTransactionIntent;
